import { Component, OnInit } from '@angular/core';
import { ContactEntity } from 'mj_generatedentities';
import { UserContextService } from 'src/app/core/services/user-context.service';

@Component({
  selector: 'app-settings-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileSettingsComponent implements OnInit {
  contact: ContactEntity;
  isSaving: boolean = false;
  isPhoneValid: boolean = true;
  hasChanges: boolean = false;

  constructor(private userContextService: UserContextService) { }

  ngOnInit(): void {
    // Load the user's contact data into the form
    this.contact = this.userContextService.Contact;
  }

  onFieldChange(): void {
    this.hasChanges = true;
  }

  validatePhone(): void {
    const phoneRegex = /^\+?(\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    this.isPhoneValid = phoneRegex.test(this.contact.Phone || '');
  }

  async saveProfile(): Promise<void> {
    if (!this.hasChanges || !this.isPhoneValid) {
      return;
    }

    this.isSaving = true;
    try {
      await this.contact.Save();
      this.hasChanges = false;
    } catch (error) {
      console.error('Error saving profile:', error);
    } finally {
      this.isSaving = false;
    }
  }
}

